import { InstrumentValueGroup } from '../clients/reporting-clients';
import { Filter } from '../types/filter';

export const instrumentValueFields: { label: string; name: Filter<InstrumentValueGroup, number> }[] = [
  { label: 'Cost Price', name: 'costPrice' },
  { label: 'Dividend', name: 'dividend' },
  { label: 'Value', name: 'estimatedValue' },
  { label: 'Interest', name: 'interest' },
  { label: 'Realized P&L', name: 'realizedProfitLoss' },
  { label: 'Unrealized P&L', name: 'unrealizedProfitLoss' }
];
